import React from 'react';
import Image from '../../../../shared/Image';
import videoIcon from '../../../../../../images/icons/icon-video-blue.svg';
import { openModal } from '../VirtualAppointmentEducationSwiper';
import '../../Notification.scss';
import './VirtualAppointmentNotification.scss';

/**
 * Add Virtual appointment notification
 */
const VirtualAppointmentNotification = () => (
  <button
    type="button"
    onClick={openModal}
    className="button-notification"
  >
    <section className="notification">
      <div className="icon">
        <Image
          source={{
            uri: videoIcon,
            width: 32,
            height: 23,
            resizeMode: 'center',
          }}
        />
      </div>
      <section className="notification-body short-block">
        <div className="notification-text">
          <strong>
            Try Virtual Appointments
          </strong>
          <p className="notification-indent">
            Connect with your clients by adding virtual appointments to your service list.
          </p>
          <strong className="notification-learn-more">Learn More</strong>
        </div>
      </section>
    </section>
  </button>
);

export default VirtualAppointmentNotification;
